// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".chart-body[data-v-29b9d822],.content[data-v-29b9d822]{height:160px}.chart-body[data-v-29b9d822]{border:1px solid #dddbda;border-top:none;background-color:#fff}.link-style[data-v-29b9d822]{text-decoration:underline}.title[data-v-29b9d822]{position:relative}.edit_btn[data-v-29b9d822]{position:absolute;right:10px;top:10px;cursor:pointer}", ""]);
// Exports
module.exports = exports;
